<template>
  <div>
    <search-sim-card-diagnose
      @submit="fetchData"
      :sim-card-id="cardId"
    />

    <a-spin :spinning="loading">
      <a-timeline v-if="data.length > 0">
        <a-timeline-item v-for="item in data" :key="item.title" :class="'item-' + item.level">
          <p>
            <a-space>
              <span>{{ item.title }}:</span>
              <span>{{ item.description }}</span>
            </a-space>
          </p>
        </a-timeline-item>
      </a-timeline>
      <a-empty v-else />
    </a-spin>
  </div>
</template>

<script>
import { diagnoseSimCard, updateSimCardDiagnoseData } from '@/api/sim_card_diagnose'
import SearchSimCardDiagnose from '@/views/sim_card_diagnose/Search'

export default {
  name: 'SimCardDiagnoseList',
  components: {
    SearchSimCardDiagnose
  },
  props: {
    cardId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      data: []
    }
  },
  methods: {
    fetchData() {
      this.loading = true

      updateSimCardDiagnoseData(this.cardId).then((res) => {
        var _this = this

        setTimeout(function() {
          const params = Object.assign({ card_id: _this.cardId })
          diagnoseSimCard(params).then((res) => {
            if (res.code === 0) {
              _this.data = res.data
            }
            _this.loading = false
          })
        }, 8000)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.item--1 {
  color: #f5222d;
}

.item-0 {
  color: #42b983;
}

.item-1 {
  color: #f7be47;
}
</style>
